var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-avatar"},[(_vm.type == 'image')?_c('image-avatar',_vm._g(_vm._b({style:(_vm.imageAvatarStyles)},'image-avatar',_vm.$props,false),_vm.$listeners)):_vm._e(),_vm._v(" "),(_vm.type == 'letter')?_c('letter-avatar',_vm._g(_vm._b({style:(_vm.letterAvatarStyles)},'letter-avatar',_vm.$props,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }